/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Toast_Create_ErrorInputs */

const vi_warehouse_position_toast_create_error = /** @type {(inputs: Warehouse_Position_Toast_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo vị trí thất bại`)
};

/**

* @param {Warehouse_Position_Toast_Create_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_toast_create_error = /** @type {((inputs?: Warehouse_Position_Toast_Create_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Toast_Create_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_toast_create_error(inputs)
});